import { postTicketRead } from '@/services/support'

// The service caps read reports at 20/min, so a thread only reports when
// something newer than the last report is on screen.
const reportedUpTo = new Map<string, string>()

export const clearReadReports = () => reportedUpTo.clear()

export const reportTicketRead = (ticketPublicId: string, seenUpTo: string) => {
  const reported = reportedUpTo.get(ticketPublicId)
  if (reported && reported >= seenUpTo) return

  reportedUpTo.set(ticketPublicId, seenUpTo)
  postTicketRead(ticketPublicId).catch(() => {
    // A rate limit or a dropped request costs a stale "Seen" light on the staff
    // side. Forgetting the watermark lets the next trigger try again.
    if (reportedUpTo.get(ticketPublicId) === seenUpTo) {
      reportedUpTo.delete(ticketPublicId)
    }
  })
}
